package earth.worldwind.geom.coords

enum class Hemisphere { N, S; }